<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Группы пользователей</div>
            <a class="title-block__btn btn-add btn-primary btn" href="/access-add-group">Добавить </a>
        </div>
        <div class="title-block__right d-none d-md-flex">
            <div class="title-block__amount">30 записей</div>
        </div>
    </div>
    <div class="table-responsive">
        <table class="table">
            <thead>
                <tr>
                    <th>Название группы</th>
                    <th>Имя руководителя группы</th>
                    <th>Действия</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Клиентовая</td>
                    <td>Иванов Дмитрий Дмитриевич</td>
                    <td>
                        <div class="table-actions">
                            <button class="table-action table-action_edit" title="Редактировать"></button>
                            <button class="table-action table-action_delete" title="Удалить"></button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <!-- Замените на компонент навигации -->
    <nav aria-label="Пример навигации по страницам">
        <ul class="pagination justify-content-center pt-4">
            <li class="page-item disabled">
                <a class="page-link page-link_prev"><svg width="7" height="11" viewBox="0 0 7 11" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 0.5L1 5.5L6 10.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                        </path>
                    </svg>
                </a>
            </li>
            <li class="page-item"><a class="page-link" href="#">1</a></li>
            <li class="page-item active"><a class="page-link" href="#">2</a></li>
            <li class="page-item"><a class="page-link" href="#">3</a></li>
            <li class="page-item">
                <a class="page-link page-link_next" href="#">
                    <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 0.5L6 5.5L1 10.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                        </path>
                    </svg>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: "AccessGroupList",
};
</script>
